import React, { Component } from "react";
import { Link } from "react-router-dom";
           
class StartEarningRewards extends Component{

		render(){
			return(
				<Link to={{ pathname: "/redirectToWebtalk" }} target="_blank" title="start earning rewards" className="btn">start earning rewards</Link>
			)
		}
}

export default StartEarningRewards;